import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(() => ({
  position: 'relative',
  zIndex: 0,
}));

export default StyledBox;
